import axios from 'axios';

const http = axios.create({
  baseURL: 'https://mobile.creditclan.com/api/v3'
});

export default http;
